<template>
	<div class="contianer main-content">

		<div class="row">

			<div class="col-12 header-container text-center pb-3">
				<div class="checkmark" alt="Checkmark"></div>
			</div>
			
			<div class="col-12 header-container text-center pb-2">
				<h2 class="lrg primary-highlight">Thank you.  Your transaction is complete!</h2>
			</div>

			<div class="col-12 col-sm-8 offset-sm-2 text-center">
				<img class="full-width shadow-bottom" src="./../assets/img/shadow_bottom.png" alt="shadow">
			</div>

		</div>

		<div class="row">
			<div class="col-12 pt-4 text-center">
				<h4 class="dark-highlight"><strong>Summary</strong></h4>
			</div>
		</div>

		<div class="row">
			<div class="offset-0 col-12 col-sm-8 offset-sm-2 pt-4">
				<ul class="no-bullets pl-0 e-transfer-bullets">
					<li>Order Total: <strong class="dark-highlight">{{ $gstate.getCurrencySymbol(pq.fiatCurrency) }}{{ pq.fiatAmount | num2decimal }} {{ pq.fiatCurrency }}</strong></li>
					<li>{{ pq.cryptoCurrency }} Amount: <strong class="dark-highlight">{{pq.cryptoAmount | num8decimal }} {{ pq.cryptoCurrency }}</strong></li>
					<li v-if="$gstate.getFlowState().nextActionParams != undefined && $gstate.getFlowState().nextActionParams.cryptoAddress != undefined">Receiving Address: <strong class="dark-highlight">{{ $gstate.getFlowState().nextActionParams.cryptoAddress }}</strong></li>
				</ul>	
			</div>
		</div>

		<div class="row panel-warning mt-4 mb-5 p-3">
			<div class="col-12 col-sm-1 text-center">
				<div class="exclamation" alt="Exclamation"></div>
			</div>
			<div class="col-12 col-sm-11 text-center text-warning">
				<p v-if="$gstate.getFlowState().paymentMethod == 'BANKTRANSFER'">
					Coins have been sent and will be delievered within the next 12 hours.
				</p>
			</div>
		</div>

		<div class="row mt-4">
			<div class="col-12 text-center">
				<a href="#" id="payment-success-next" class="btn next-btn" v-on:click.prevent="done">Done</a>
			</div>
		</div>
	</div>
</template>

<script>

import { eventBus } from './../main'

export default {
    data(){
        return {
            pq: this.$gstate.getFlowState(),
        }
	},
	mounted(){
		eventBus.$emit('logGTMTransactionEvent', "transactionComplete");
	},
	created(){
		this.$emit('setLeaveNotification', false);
		this.$emit('setRateHoldTimer', false);
	},
    methods: {
        done: function (){
            this.$emit('reset', false);
            this.$gstate.redirectSuccess();
        }
    }
}
</script>
